const defaultState = {
  lottie: {},
};

const preloadReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'PRELOAD_LOTTIE': {
      const preLoadedMap = {};
      action.preLoaded.forEach(preLoaded => {
        if (preLoaded !== null) {
          preLoadedMap[preLoaded.url] = preLoaded.data;
        }
      });

      return {
        ...state,
        lottie: {
          ...state.lottie,
          ...preLoadedMap,
        },
      };
    }
    default:
      return state;
  }
};

export default preloadReducer;
